import { render, staticRenderFns } from "./Icon3d.vue?vue&type=template&id=0d005822&scoped=true"
import script from "./Icon3d.vue?vue&type=script&lang=js"
export * from "./Icon3d.vue?vue&type=script&lang=js"
import style0 from "./Icon3d.vue?vue&type=style&index=0&id=0d005822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d005822",
  null
  
)

export default component.exports